import {Mapper} from '@s-ui/domain'

export class NavigationDataVOToNavigationLinksVOMapper extends Mapper {
  constructor({config, navigationLinksValueObjectFactory}) {
    super()
    this._config = config
    this._navigationLinksValueObjectFactory = navigationLinksValueObjectFactory
  }

  map = navigationDataValueObject => {
    const items = navigationDataValueObject.getItems()
    const itemIndex = items.findIndex((item, index) => {
      return index >= this._currentPosition && String(item.id) === String(this._id)
    })
    const backUrl = navigationDataValueObject.getSearchUrl()

    // current item is unrelated to previous search
    if (itemIndex < 0) return this._navigationLinksValueObjectFactory()

    // item is first on list
    if (itemIndex === 0 && items.length > 1) {
      const nextUrl = items[itemIndex + 1].url || backUrl
      return this._navigationLinksValueObjectFactory({
        backUrl,
        currentPosition: itemIndex,
        nextUrl,
        prevUrl: navigationDataValueObject.getPrevPageUrl()
      })
    }

    // item is last on list
    if (itemIndex === items.length - 1 && items.length > 1) {
      const prevUrl = items[itemIndex - 1].url || navigationDataValueObject.getSearchUrl()
      return this._navigationLinksValueObjectFactory({
        backUrl,
        currentPosition: itemIndex,
        nextUrl: navigationDataValueObject.getNextPageUrl(),
        prevUrl
      })
    }

    // standard case: item is somewhere in the middle of the list
    if (items.length > 1) {
      return this._navigationLinksValueObjectFactory({
        backUrl,
        currentPosition: itemIndex,
        nextUrl: items[itemIndex + 1].url,
        prevUrl: items[itemIndex - 1].url
      })
    }

    // only one item on list
    return this._navigationLinksValueObjectFactory({
      backUrl,
      currentPosition: itemIndex
    })
  }

  setParams = ({currentPosition, id}) => {
    this._currentPosition = currentPosition
    this._id = id
    return this
  }
}
